import React, { Component } from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import ErrorDisplay from '../utility/ErrorDisplay';
import LottieLoader from '../utility/LottieLoader';
import BookingItem from './BookingItem';
import { Helmet } from 'react-helmet';
import ButtonLink from '../utility/ButtonLink';
import OtherTrips from '../TripDetails/OtherTrips';
import bookingEmptyImg from '../../images/img_bookingempty.png';
import { withTranslation } from 'react-i18next';
import Cookies from 'js-cookie';

import {
  clearApiError,
} from '../../actions/api';

import {
  fetchMyBookings,
} from '../../actions/myBookings';

import {
  deleteSavedInfo,
} from '../../actions/booking';

import {
  doCheckCurrentUser,
} from '../../actions/auth';

import {
  SITE_TITLE,
} from '../../constants';

class MyBookings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initData: false, //Ensures we have pre-populated booking pax / date before rendering menu
      showUpcoming: true,
    };
    this.initData = this.initData.bind(this);
    this.deleteSavedBooking = this.deleteSavedBooking.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    const { clearApiError } = this.props;
    clearApiError();
    this.initData();   
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  async initData() {
    const { fetchMyBookings, doCheckCurrentUser } = this.props;
    await doCheckCurrentUser();
    await fetchMyBookings();
        
    const { error } = this.props;
    if(!error && this._isMounted) {
      this.setState({
        initData: true,
      });
    }
  }

  async deleteSavedBooking(uuid) {
    const { deleteSavedInfo, fetchMyBookings } = this.props;
    await deleteSavedInfo(decodeURIComponent(Cookies.get('XSRF-TOKEN')), uuid);
    await fetchMyBookings();
  }

  sortByDaysLeftUpcoming(a, b) {
    return a.remaining_days - b.remaining_days;
  }

  sortByDaysLeftPrevious(a, b) {
    return b.remaining_days - a.remaining_days;
  }

  render() {
    const {
      showUpcoming,
      initData,
    } = this.state;
    const {
      loading,
      authLoading,
      error,
      myBookings,
      t,
    } = this.props;

    if(error) {
      return (
        <ErrorDisplay error={error} />
      );
    }
    if(loading || authLoading || !initData) {
      return (
        <LottieLoader />
      );
    }

    let bookingsToShow = [...myBookings].filter((booking) => booking.upcoming === showUpcoming);
    if(showUpcoming) {
      bookingsToShow = bookingsToShow.sort(this.sortByDaysLeftUpcoming);
    } else {
      bookingsToShow = bookingsToShow.sort(this.sortByDaysLeftPrevious);
    }

    return (
      <>  
        <Helmet>
          <title>{ t('trip:yourBookings') } | { SITE_TITLE }</title>
        </Helmet>
        <div className="fe-my-bookings-container">
          <div className="container">
            <h1 className="fe-heading">{t('trip:yourBookings')}</h1>
            <div className="fe-form-toggle">
              <span
                className={`fe-form-toggle-btn ${showUpcoming ? 'active' : ''}`}
                onClick={() => this.setState({ showUpcoming: true })}
              >
                {t('gen:upcoming')}
              </span>
              <span
                className={`fe-form-toggle-btn ${!showUpcoming ? 'active' : ''}`}
                onClick={() => this.setState({ showUpcoming: false })}
              >
                {t('gen:previous')}
              </span>
            </div>
            {bookingsToShow && bookingsToShow.length > 0 ?
              <div className="fe-my-bookings-list">
                {bookingsToShow.map((booking) => (
                  <BookingItem
                    key={booking.id}
                    booking={booking}
                    handleDelete={this.deleteSavedBooking}
                  />
                ))}
              </div> : 
              <div className="fe-my-bookings-empty">
                <p>
                  {t('trip:noBookings', { upcoming: showUpcoming ? t('gen:upcoming') : t('gen:previous') })} {showUpcoming ? t('trip:pickAGetaway') : t('trip:expYourFirst')}
                </p>
                <img src={bookingEmptyImg} alt=""/>
              </div>
            }
            {myBookings && myBookings.length < 1 ? 
              <OtherTrips
                full
                title="trip:popularGetaways"
              /> : null}
            <div className="fe-my-bookings-more">
              <p>{showUpcoming ? t('trip:lookingForMore') : t('trip:plentyAwait')}</p>
              <ButtonLink className="fe-u-btn" to="/">{t('trip:exploreGetaways')}</ButtonLink>
            </div>
          </div>
        </div>
      </>
    );
  }
}

MyBookings.propTypes = {
  clearApiError: PropTypes.func.isRequired,
  fetchMyBookings: PropTypes.func.isRequired,
  doCheckCurrentUser: PropTypes.func.isRequired,
  error: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  authLoading: PropTypes.bool.isRequired,
  myBookings: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
  deleteSavedInfo: PropTypes.func.isRequired,
};

const mapStateToProps = ({ myBookingsState, apiState, authState }) => ({
  myBookings: myBookingsState.myBookings,
  loading: myBookingsState.loading,
  authLoading: authState.loading,
  error: apiState.error,
});

const mapDispatchToProps = {
  clearApiError,
  fetchMyBookings,
  doCheckCurrentUser,
  deleteSavedInfo,
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(MyBookings));